export enum CommunityUserUserState {
    ACTIVE = 1,
    CHANGE_EMAIL = 2,
    CREATING = 3,
    DELETED = 4,
    DELETE_ACCOUNT = 5,
    INACTIVE = 6,
    LOST_PASSWORD = 7,
    ASK_ACTIVATION = 8,
    CREATING_FOR_FLEET = 9
}

export interface CommunityUserUserData {
    id: number
    email: string
    username: string
    locale: string
    state: CommunityUserUserState
    defaultRfidPassId?: number
    vehicleVersionId?: number
    avatarFilename?: string
    firstName?: string
    lastName?: string
    fullName: string
    birthday?: string
    contractId?: number
    businessUnitId?: number
    businessUnitName?: string
    rank: UserRank
    level: number
    currentPoints: number
    hasPassword: boolean
    marketingConsent: boolean
}
export interface UserAddress {
    firstName?: string
    name?: string
    company?: string
    addressLine1: string
    addressLine2?: string
    city: string
    postalCode: string
    countryName: string
    countryCode: string
    phone: string
    vatNumber?: string
    email?: string
}

export interface FeedbackUser {
    avatar: string | null
    id: number
    level: number
    rank: string
    slug: string
    username: string
}

export enum UserRank {
    MEMBER = 1,
    TRUSTED = 2,
    ADMIN = 3,
    AGENT = 4
}

export enum TeslaLinkStatus {
    INITIATED = 'INITIATED',
    CONFIRMED = 'CONFIRMED'
}

export enum UserState {
    ACTIVE = 1,
    CHANGE_EMAIL = 2,
    CREATING = 3,
    DELETED = 4,
    DELETE_ACCOUNT = 5,
    INACTIVE = 6,
    LOST_PASSWORD = 7,
    ASK_ACTIVATION = 8,
    CREATING_FOR_FLEET = 9
}
